import { Component } from "../components/index"
import gsap from "gsap"
import { qsa, qs } from "../utils/index"
import Marquee from "../components/Marquee"
import TextSplitScrollTrigger from "../components/TextSplitScrollTrigger"

export default class Samples extends Component {
  constructor(obj) {
    super(obj)

    this.marqueeDOM = qs(".marquee", this.el)

    this.splitText = qsa("[data-split]", this.el)
    this.textSplitter = new TextSplitScrollTrigger({
      el: this.el,
      splitText: this.splitText,
      animate: this.animate.bind(this),
    })

    gsap.set(this.el, { autoAlpha: 0 })
  }

  on() {
    this.marquee = new Marquee(this.marqueeDOM)
  }

  resize() {
    this.marquee.resize()
  }

  animate() {
    const title = qsa(".title .char-0", this.el)

    gsap.from(title, {
      y: "100%",
      duration: 1.2,
      stagger: 0.03,
      scrollTrigger: {
        trigger: title,
        start: "top bottom",
      },
    })
    gsap.set(this.el, { autoAlpha: 1 })
  }
}
